<template>
  <div class="ev-simulate-page">
    <div class="toolbar">
      <div class="toolbar-left">
        <el-form size="mini" :inline="true" class="compact-form">
          <el-form-item label="推导">
            <el-date-picker v-model="param.startDate" type="date" value-format="yyyy-MM-dd" placeholder="开始日期"
              style="width: 130px" :disabled="running"></el-date-picker>
          </el-form-item>
          <el-form-item label="天数">
            <el-input-number v-model="param.days" :min="1" :max="30" :controls="false" style="width: 52px"
              :disabled="running"></el-input-number>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" :loading="running" @click="startSimulate">开始推导</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="toolbar-right-area">
        <el-form size="mini" :inline="true" class="compact-form">
          <el-form-item label="路线">
            <el-select v-model="filterPathId" placeholder="全部路线" clearable style="width: 120px">
              <el-option v-for="item in pathOpts" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期">
            <el-date-picker v-model="viewDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"
              style="width: 130px" @change="loadView"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button size="mini" :loading="viewLoading" @click="loadView">刷新</el-button>
          </el-form-item>
        </el-form>

        <div class="toolbar-meta">
          <div class="toolbar__summary" v-if="dayView">
            <span class="summary-tag">账本 {{ solveStatus }}</span>
            <span class="summary-tag">已派 {{ filteredAssignedPerson }} 人</span>
            <span class="summary-tag">未派 {{ filteredUnassignedPerson }} 人</span>
            <span class="summary-tag">行程 {{ filteredTripCount }} 个</span>
          </div>
          <div class="toolbar__progress" v-if="taskId && task && task.status === 0">
            <span class="status-text">{{ progressText }}</span>
            <el-progress :percentage="progressPercent" :stroke-width="6" :show-text="false"
              class="inline-progress"></el-progress>
            <span class="progress-pct">{{ progressPercent }}%</span>
          </div>
          <span class="toolbar__error" v-if="task && task.status === 2">{{ task.errorMsg }}</span>
          <span class="toolbar__done" v-else-if="taskId && task && task.status === 1">推导完成</span>
        </div>
      </div>
    </div>

    <div class="main-content">
      <el-tabs v-model="tab" class="fill-tabs">
        <el-tab-pane name="unassigned">
          <span slot="label">已订（{{ filteredUnassignedPerson }}人）</span>

          <unassigned-order ref="unassignedRef" :list="filteredUnassignedOrders" :date="viewDate"
            :table-height="tableHeight" />
        </el-tab-pane>

        <el-tab-pane name="dispatched">
          <span slot="label">已派（{{ filteredAssignedPerson }}人）</span>

          <simulated-dispatched-order ref="dispatchedRef" :trips="filteredDispatchedTrips"
            :table-height="tableHeight" />
        </el-tab-pane>

        <el-tab-pane name="idle">
          <span slot="label">可售余票</span>

          <idle-vehicle-panel ref="idleRef" :rows="filteredSellableSnapshots" :table-height="tableHeight" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { submitEvSimulate, getEvSimulateTask, getEvPlanView } from "@/api/ev_solver";

import { DateUtil } from "@/util";

import { mapState } from "vuex";

import UnassignedOrder from "./UnassignedOrder";

import SimulatedDispatchedOrder from "./SimulatedDispatchedOrder";

import IdleVehiclePanel from "./IdleVehiclePanel";

export default {
  components: {
    UnassignedOrder,

    SimulatedDispatchedOrder,

    IdleVehiclePanel
  },

  data() {
    return {
      tab: "dispatched",
      viewDate: DateUtil.getDayStr(0, "yyyy-MM-dd"),
      dayView: null,
      viewLoading: false,
      filterPathId: null,
      param: {
        startDate: DateUtil.getDayStr(0, "yyyy-MM-dd"),

        days: 3
      },
      taskId: null,
      task: null,
      running: false,
      pollTimer: null,
      tableHeight: 800
    };
  },

  computed: {
    ...mapState({
      pathOpts: (state) => state.pathList
    }),

    solveStatus() {
      const summary = this.dayView && this.dayView.solveSummary;

      return (summary && summary.status) || "-";
    },

    filteredUnassignedOrders() {
      const list = (this.dayView && this.dayView.unassignedOrders) || [];

      if (!this.filterPathId) return list;

      return list.filter((item) => item.pathId === this.filterPathId);
    },

    filteredDispatchedTrips() {
      const list = (this.dayView && this.dayView.dispatchedTrips) || [];

      if (!this.filterPathId) return list;

      return list.filter((item) => item.pathId === this.filterPathId);
    },

    filteredAssignedPerson() {
      return this.filteredDispatchedTrips.reduce((sum, trip) => sum + (trip.assignedSeats || 0), 0);
    },

    filteredUnassignedPerson() {
      return this.filteredUnassignedOrders.reduce((sum, item) => sum + (item.number || 0), 0);
    },

    filteredTripCount() {
      return this.filteredDispatchedTrips.length;
    },

    filteredSellableSnapshots() {
      const list = (this.dayView && this.dayView.sellableSnapshots) || [];

      if (!this.filterPathId) return list;

      return list.filter((item) => item.pathId === this.filterPathId);
    },


    progressPercent() {
      if (!this.task || !this.task.totalDays) return 0;

      return Math.round((this.task.currentDay / this.task.totalDays) * 100);
    },

    progressText() {
      if (!this.task) return "";

      if (this.task.status === 0) {
        const day =
          this.task.dayResults && this.task.dayResults.length
            ? this.task.dayResults[this.task.dayResults.length - 1].date
            : this.param.startDate;

        return `推导中 第 ${this.task.currentDay}/${this.task.totalDays} 天 (${day})...`;
      }

      if (this.task.status === 1) return "推导完成";

      return `推导失败：${this.task.errorMsg || "未知错误"}`;
    }
  },

  mounted() {
    this.loadView();

  },

  beforeDestroy() {
    this.stopPoll();
  },

  methods: {
    loadView(silent) {
      if (!this.viewDate) {
        return;
      }

      this.viewLoading = !silent;

      getEvPlanView({
        date: this.viewDate,

        _hideLoading: !!silent
      })
        .then((res) => {
          this.dayView = res.data;
        })
        .finally(() => {
          this.viewLoading = false;
        });
    },

    startSimulate() {
      if (!this.param.startDate) {
        this.$message.error("请选择开始推导日期");
        return;
      }

      this.stopPoll();
      this.taskId = null;
      this.task = null;
      this.running = true;

      submitEvSimulate({
        startDate: this.param.startDate,
        days: this.param.days
      })
        .then((res) => {
          this.taskId = res.data.taskId;
          this.pollTask();
          this.pollTimer = setInterval(() => this.pollTask(), 5000);
        })
        .catch(() => {
          this.running = false;
        });
    },

    pollTask() {
      if (!this.taskId) return;

      getEvSimulateTask(this.taskId).then((res) => {
        this.task = res.data;
        if (this.task.status === 1) {
          this.running = false;
          this.stopPoll();
          this.$message.success("推导完成");
        } else if (this.task.status === 2) {
          this.running = false;

          this.stopPoll();
        }
      });
    },

    stopPoll() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer);

        this.pollTimer = null;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.ev-simulate-page {
  display: flex;

  flex-direction: column;

  height: calc(100vh - 100px);

  padding: 6px 12px 8px;

  box-sizing: border-box;

  overflow: hidden;
}

.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 32px;
  margin-bottom: 6px;
  padding-bottom: 6px;
  border-bottom: 1px solid #ebeef5;
  flex-shrink: 0;
  flex-wrap: wrap;
  row-gap: 8px;
}

.toolbar-left,
.toolbar-right-area {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.toolbar-right-area {
  gap: 12px;
  margin-left: auto;
  padding-left: 12px;
  border-left: 1px solid #dcdfe6;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.toolbar-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.toolbar__summary {
  display: flex;

  align-items: center;

  flex-wrap: wrap;

  gap: 6px;
}

.summary-tag {
  font-size: 12px;

  color: #606266;

  background: #f0f2f5;

  padding: 2px 8px;

  border-radius: 2px;

  white-space: nowrap;
}

.toolbar__progress {
  display: flex;

  align-items: center;

  gap: 8px;

  min-width: 160px;
}

.inline-progress {
  width: 120px;

  flex-shrink: 0;
}

.progress-pct {
  font-size: 12px;

  color: #606266;

  min-width: 32px;
}

.status-text {
  font-size: 12px;

  color: #606266;

  white-space: nowrap;
}

.toolbar__done {
  font-size: 12px;

  color: #67c23a;

  white-space: nowrap;
}

.toolbar__error {
  font-size: 12px;

  color: #f56c6c;

  max-width: 240px;

  overflow: hidden;

  text-overflow: ellipsis;

  white-space: nowrap;
}

.compact-form {
  /deep/ .el-form-item {
    margin-bottom: 0;

    margin-right: 10px;
  }

  /deep/ .el-form-item__label {
    padding-right: 4px;

    font-size: 12px;
  }

}

.toolbar-left,
.toolbar-right-area {
  /deep/ .el-form {
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;
  }
}

.main-content {
  flex: 1;

  min-height: 0;

  display: flex;

  flex-direction: column;
}

.fill-tabs {
  flex: 1;

  min-height: 0;

  display: flex;

  flex-direction: column;

  /deep/ .el-tabs__header {
    margin-bottom: 6px;
  }

  /deep/ .el-tabs__content {
    flex: 1;

    min-height: 0;
  }

  /deep/ .el-tab-pane {
    height: 100%;
  }
}
</style>
